var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('CLink',{attrs:{"to":_vm.dealerSiteService.resolvePageRoute(_vm.contactPage).href}},[_vm._v("\n  "+_vm._s(_vm.$t('more'))),_c('CIcon',{staticClass:"tw-ml-2",attrs:{"icon":_vm.icons.arrowRight}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }